import React, { useContext, useMemo } from "react";

import "./EUMRVVoyages.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	EUMRV_VOYAGES_HEADERS,
	EUVoyagesDerogationGeographicScopeColumns,
} from "../../../../../../constants/CustomTableHeaders";
import { FeatureType } from "../../../../../../constants/FeatureToggles";
import { ClaimsContext } from "../../../../../../services/ClaimsService";

const EuVoyagesDerogationGeographicScope = ({ data }) => {

	//feature toggle for blend fuel registry
	const { claims, userHasFeature } = useContext(ClaimsContext) || {};
	
	const mrvAccessorKeys = [
		"co2Mrv",
		"ch4Mrv",
		"n2oMrv",
		"co2EqMrv",
	];

   
	const dynamicColumns = useMemo(() => {
		
			return EUVoyagesDerogationGeographicScopeColumns?.filter(
				col => !mrvAccessorKeys.includes(col.accessorKey)
			);
		
	}, [EUVoyagesDerogationGeographicScopeColumns]);

	return (
		<div className="EUMRV-custom-table-container mt-3 eu_mrv_voyage">
			<CustomTable
				columnsData={dynamicColumns}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_VOYAGES_HEADERS.GEOGRAPHIC_SCOPE,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default EuVoyagesDerogationGeographicScope;
